import styled, { css } from 'styled-components';
import { COLOR_VARIANT } from '../../constants/color-variant.js';
import '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import { clickableCursorStyle, disabledCursorStyle } from '../../mixins/cursor.js';
import { fontWeightMixin } from '../../mixins/font.js';

const sizeBasedStyle = {
    medium: {
        padding: "0px 20px",
        fontSize: "0.875rem",
        height: "44px",
    },
    small: {
        padding: "0 16px",
        fontSize: "0.875rem",
        height: "40px",
        gap: "5px",
    },
    xs: {
        padding: "0 20px",
        fontSize: "0.875rem",
        height: "36px",
        gap: "5px",
    },
    auto: {
        padding: "0 8px",
        fontSize: "0.875rem",
        height: "auto",
        gap: "5px",
    },
    dot: {},
};
const StyledChip = styled.div `
    ${fontWeightMixin};
    display: inline-flex;
    gap: 10px;
    line-height: 1.5;
    white-space: nowrap;
    align-items: center;

    ${({ outlined, filled, color, fillColor, faceColor, outlineColor, fontColor, showHoverEffect, }) => {
    var _a, _b;
    const { primary, secondary } = (_a = COLOR_VARIANT[color]) !== null && _a !== void 0 ? _a : {};
    return css(Object.assign({ color: fontColor ? fontColor : faceColor !== null && faceColor !== void 0 ? faceColor : primary, backgroundColor: filled ? fillColor !== null && fillColor !== void 0 ? fillColor : secondary : "white", borderStyle: "solid", borderWidth: outlined ? 2 : 0, borderColor: outlined
            ? (_b = outlineColor !== null && outlineColor !== void 0 ? outlineColor : faceColor) !== null && _b !== void 0 ? _b : primary
            : "unset" }, (showHoverEffect && {
        "&:hover": {
            backgroundColor: fillColor !== null && fillColor !== void 0 ? fillColor : secondary,
        },
    })));
}}

    ${({ radius = 4, blockWidth = false, size = "medium", dotSize = 2 }) => {
    return css(Object.assign(Object.assign(Object.assign({}, sizeBasedStyle[size]), (size === "dot" && {
        minWidth: dotSize * 4,
        width: dotSize * 4,
        height: dotSize * 4,
    })), { borderRadius: radius, width: blockWidth ? "100%" : "unset" }));
}}

    ${({ padded }) => {
    return padded
        ? ""
        : css({
            padding: 0,
        });
}}

    ${({ justifyContent }) => {
    return css({
        justifyContent: justifyContent !== null && justifyContent !== void 0 ? justifyContent : "flex-start",
    });
}}

    ${({ onClick }) => onClick && clickableCursorStyle}
    ${({ disabled }) => disabled && disabledCursorStyle}
`;

export { StyledChip };
//# sourceMappingURL=Chip.styles.js.map
